import { Injectable } from '@angular/core';
import { SecurityInfo, SymbolType } from '../../../../../../domain/symbol.domain';
import { MarketType } from '../../../../../../domain/market.domain';
import { TradingAccount } from '../../../../../../domain/account.domain';
import { OrderSecurity } from '../../../../../../domain/security.domain';
import { DateService } from '../../../../../../services/date/date.service';
import {
  OrderRequest,
  TradingCredential,
  Strategy,
  OrderItem,
  GicExtendedTerms,
  EquityOrderAction, GicType
} from '../../../../domain';
import { BackendMapper } from '../../../domain/services.domain';
import { CreateOrderMapper } from './create-order-mapper.service';
import type { GicFormModel } from '../../../domain/order-entry.domain';

@Injectable()
export class CreateGicOrderMapper extends CreateOrderMapper<GicFormModel> implements BackendMapper<GicFormModel> {

  getMapperType(): OrderSecurity {
    return 'gic';
  }

  createCaptureRequest(formModel: GicFormModel, selectedAccount: TradingAccount, tradingCredential: TradingCredential,
                       strategy: Strategy = Strategy.SPL): OrderRequest {
    const request = {
      orderTerms: {
        accountInfo: { accountId: selectedAccount.id },
        afterMarket: formModel.isGicMarketClosed,
        order: this.getItems(formModel),
        pricePlan: null,
        strategy
      },
      conditionFilter: 'STANDARD'
    } as OrderRequest;
    if (tradingCredential !== undefined) {
      request.tradingCredential = tradingCredential;
    }
    return request;
  }

  getItems(formModel: GicFormModel): Array<OrderItem> {
    const extendedTerms: GicExtendedTerms = {
      amount: formModel.orderAmount,
      orderAction: EquityOrderAction.BUY,
      ratePercent: formModel.selectedGic.gicRate.rate,
      rolloverInstructions: 'NO_ROLLOVER', // not available on WB
      compoundFrequency: formModel.selectedFrequency
    };

    if (formModel.selectedType === GicType.SHORT) {
      const dayInMilliseconds = 24 * 60 * 60 * 1000;
      const currentDate = DateService.stripTime(formModel.currentDate);
      extendedTerms.termInDays = Math.round(Math.abs((formModel.maturityDate.valueOf() - currentDate.valueOf()) / dayInMilliseconds));
    } else {
      extendedTerms.termInYears = formModel.selectedTerm;
    }
    const securityInfo: SecurityInfo = {
      type: SymbolType.GIC,
      symbol: formModel.selectedGic.gicRate.symbol,
      market: formModel.selectedGic.currencyCd === 'CAD' ? MarketType.CA : MarketType.US
    };

    return [{
      extendedTerms,
      security: securityInfo,
      quantity: formModel.orderAmount
    }];

  }

}

